import React from "react";
import { Trans } from "react-i18next";

/**
 * Renders a translation key whose value contains lightweight markup tags:
 *   <em>…</em>  → italic / accent
 *   <strong>…</strong>
 *
 * Use it for headlines so translators can place the emphasis where it
 * reads naturally in each language — e.g. English puts the em on
 * "right now", Spanish puts it on "ahora mismo".
 *
 * Usage:
 *   <T i18nKey="onboarding.step_stage.h" />
 */
export default function T({ i18nKey, values, className }) {
  return (
    <span className={className}>
      <Trans
        i18nKey={i18nKey}
        values={values}
        components={{ em: <em />, strong: <strong /> }}
      />
    </span>
  );
}
